import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

api.interceptors.response.use(null, async (error) => {
  const cfg = error.config;
  if (error.response?.status === 401 && cfg && !cfg._retried && !cfg.url.startsWith("/auth/")) {
    cfg._retried = true;
    try {
      await api.post("/auth/refresh");
      return api(cfg);
    } catch {
      return Promise.reject(error);
    }
  }
  return Promise.reject(error);
});

export const formatApiError = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? `${e.loc?.length ? `${String(e.loc[e.loc.length - 1]).replace("_", " ")}: ` : ""}${e.msg}` : JSON.stringify(e))).join(". ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
};
